import React from 'react';

const SecurityArchitectureDiagram: React.FC = () => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-lg transition-all duration-300">
      <h2 className="mb-6 text-2xl font-bold text-center text-blue-800">安全架构图</h2>
      <p className="mb-4 text-gray-600 text-center max-w-4xl mx-auto">
        全方位多层次安全保障体系，实现基础设施、应用、数据与管理的立体防护
      </p>
      
      <div className="relative w-full h-[600px] bg-gradient-to-b from-gray-50 to-gray-100 rounded-lg p-6 grid grid-cols-5 gap-4">
        {/* 左侧安全分层 */}
        <div className="col-span-1 flex flex-col justify-center items-center gap-4">
          <div className="bg-blue-600 text-white p-3 rounded-lg w-full text-center font-medium shadow-md">
            安全管理层
          </div>
          <div className="h-8 border-l-2 border-dashed border-blue-400"></div>
          
          <div className="bg-indigo-600 text-white p-3 rounded-lg w-full text-center font-medium shadow-md">
            数据安全层
          </div>
          <div className="h-8 border-l-2 border-dashed border-blue-400"></div>
          
          <div className="bg-purple-600 text-white p-3 rounded-lg w-full text-center font-medium shadow-md">
            应用安全层
          </div>
          <div className="h-8 border-l-2 border-dashed border-blue-400"></div>
          
          <div className="bg-red-600 text-white p-3 rounded-lg w-full text-center font-medium shadow-md">
            基础设施安全层
          </div>
        </div>
        
        {/* 右侧安全具体措施 */}
        <div className="col-span-4 grid grid-rows-4 gap-4">
          {/* 安全管理层 */}
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <h3 className="text-blue-800 font-bold mb-3">安全管理层</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 1.944A11.954 11.954 0 012.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0110 1.944zM11 14a1 1 0 11-2 0 1 1 0 012 0zm0-7a1 1 0 10-2 0v3a1 1 0 102 0V7z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">安全策略管理</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">统一安全策略制定与执行</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                  </svg>
                  <span className="font-medium text-sm">安全责任体系</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">各级安全责任明确划分</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">安全培训</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">定期安全意识与技能培训</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" />
                  </svg>
                  <span className="font-medium text-sm">应急响应</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">安全事件快速处置流程</p>
              </div>
            </div>
          </div>
          
          {/* 数据安全层 */}
          <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
            <h3 className="text-indigo-800 font-bold mb-3">数据安全层</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">数据加密</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">敏感数据传输与存储加密</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2h-1.528A6 6 0 004 9.528V4z" />
                    <path fillRule="evenodd" d="M8 10a4 4 0 00-3.446 6.032l-1.261 1.26a1 1 0 101.414 1.415l1.261-1.261A4 4 0 108 10zm-2 4a2 2 0 114 0 2 2 0 01-4 0z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">数据分类</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">数据敏感度分级管理</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">访问控制</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">严格数据访问权限控制</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                  </svg>
                  <span className="font-medium text-sm">备份恢复</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">数据定期备份与恢复机制</p>
              </div>
            </div>
          </div>
          
          {/* 应用安全层 */}
          <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
            <h3 className="text-purple-800 font-bold mb-3">应用安全层</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v-1l1-1 1-1-.257-.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">身份认证</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">多因素身份验证机制</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">访问授权</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">基于角色的访问控制</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M6.625 2.655A9 9 0 0119 11a1 1 0 11-2 0 7 7 0 00-9.625-6.492 1 1 0 11-.75-1.853zM4.662 4.959A1 1 0 014.75 6.37 6.97 6.97 0 003 11a1 1 0 11-2 0 8.97 8.97 0 012.25-5.953 1 1 0 011.412-.088z" clipRule="evenodd" />
                    <path fillRule="evenodd" d="M5 11a5 5 0 1110 0 1 1 0 11-2 0 3 3 0 10-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 11-1.838-.789A9.964 9.964 0 005 11z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">安全编码</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">安全开发生命周期</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">漏洞防护</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">定期漏洞扫描与修复</p>
              </div>
            </div>
          </div>
          
          {/* 基础设施安全层 */}
          <div className="bg-red-50 p-4 rounded-lg border border-red-200">
            <h3 className="text-red-800 font-bold mb-3">基础设施安全层</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">边界防护</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">防火墙与入侵检测</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" />
                  </svg>
                  <span className="font-medium text-sm">网络隔离</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">网络分区与访问控制</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" />
                  </svg>
                  <span className="font-medium text-sm">防DDoS</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">抵御分布式拒绝服务攻击</p>
              </div>
              
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="font-medium text-sm">运维安全</span>
                </div>
                <p className="text-xs text-gray-600 mt-1">最小权限原则运维管理</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-6 p-4 bg-blue-50 rounded-lg shadow-sm">
        <h3 className="font-semibold text-blue-800 mb-2">安全架构说明</h3>
        <p className="text-sm text-gray-700">
          全面安全架构采用分层防御策略，从基础设施安全、应用安全、数据安全到安全管理，形成立体防护体系。
          在基础设施层，部署防火墙、入侵检测、DDoS防护等组件；应用层实施身份认证、访问控制、安全编码等措施；
          数据层执行数据加密、分类分级、访问控制等策略；管理层则制定安全策略、明确责任体系、定期培训与应急响应。
          整体架构符合等保三级要求，通过技术与管理手段双管齐下，确保系统全生命周期安全。
        </p>
      </div>
    </div>
  );
};

export default SecurityArchitectureDiagram; 